import { defineMessages } from 'react-intl';

export const wizardRatesPanelMessages = defineMessages({
  title: {
    defaultMessage: 'Rates',
    id: 'tnQeKK',
    description: 'Title for the wizard rates panel',
  },
  noRates: {
    defaultMessage: 'No rates available yet. Complete the steps to see rates.',
    id: 'Vja7rK',
    description: 'Empty state message when no freight rates are loaded in the wizard',
  },
  noInsuredRates: {
    defaultMessage: "We couldn't get rates with insurance at this time. Either try again later or remove insurance.",
    id: 't0yvLl',
    description:
      'Empty state message when freight quotes came back but none include insurance pricing while the seller has insurance enabled',
  },
  insuredRatesError: {
    defaultMessage: 'Error requesting insured rates',
    id: 'eeAB76',
    description:
      'Error alert shown in the freight rates panel when quotes returned but none include insurance pricing while insurance is enabled',
  },
  completeRequiredFields: {
    defaultMessage: 'Complete the required fields to see rates.',
    id: '/5sGL/',
    description: 'Empty state message in the rates panel when rate-required fields are still missing',
  },
  refreshAriaLabel: {
    defaultMessage: 'Refresh rates',
    id: 'ePii7q',
    description: 'Aria label for the refresh rates icon button',
  },
  viewMoreRates: {
    defaultMessage: 'View More Rates ({count})',
    id: 'BU2EVu',
    description: 'Ghost button to reveal additional freight rates',
  },
  standardColumnHeader: {
    defaultMessage: 'Standard',
    id: 'd5oCEm',
    description: 'Column header labeling the standard rate column above the wizard rate cards',
  },
  guaranteedColumnHeader: {
    defaultMessage: 'Guaranteed',
    id: 'ISBgdO',
    description: 'Column header labeling the guaranteed rate column above the wizard rate cards',
  },
});
